import { mergeAttributes, Node } from '@tiptap/core'

export interface VideoAttrs {
  src: string
  s3Key?: string | null
  title?: string | null
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    video: {
      /** Insert an inline video node. */
      setVideo: (options: VideoAttrs) => ReturnType
    }
  }
}

/**
 * Inline video node. Persists the stable `s3Key` so the API can re-sign `src`
 * on every read; renders a native <video> player.
 */
export const Video = Node.create({
  name: 'video',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      src: { default: null },
      s3Key: { default: null },
      title: { default: null },
    }
  },

  parseHTML() {
    return [{ tag: 'video[src]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'video',
      mergeAttributes(HTMLAttributes, {
        controls: 'true',
        preload: 'metadata',
        style: 'max-width:100%;border-radius:8px;display:block;margin:12px 0;',
      }),
    ]
  },

  addCommands() {
    return {
      setVideo:
        (options) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: options }),
    }
  },
})
